"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _queryList = _interopRequireDefault(require("@/components/queryList"));
var _methods = require("@/components/Store/SalesKPIRecord/methods");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var curDateTree = (0, _methods.getCurDateTree)(); // 获取当前时间相关 月份、季度、年份
var _default = exports.default = {
  components: {
    QueryList: _queryList.default
  },
  data: function data() {
    return {
      pageName: 'salesPerformance',
      searchQuery: {
        type: '1',
        value: curDateTree.month
      },
      apiModule: 'kpiSet',
      urlModule: 'REPORT'
    };
  },
  computed: {
    domData: function domData() {
      return {
        pc: {
          label: this.$t('sfe.salesPerformance.pc'),
          inputType: 'pcd',
          level: 2,
          regionProps: {
            expandTrigger: 'hover',
            checkStrictly: true
          },
          keyList: ['region', 'regionCode', 'city', 'cityCode']
        }
      };
    },
    tableButtons: function tableButtons() {
      return {
        export: {
          fileName: this.$t('sfe.route.salesperformancecitytotal'),
          apiUrl: '/protected/pc/report/city/salePerformance/export'
        }
      };
    },
    tableDom: function tableDom() {
      return {
        region: {
          label: this.$t('sfe.salesPerformance.region')
        },
        city: {
          label: this.$t('sfe.salesPerformance.city'),
          click: true
        },
        cityAop: {
          label: this.$t('sfe.salesPerformance.cityAop')
        },
        aopGap: {
          label: this.$t('sfe.salesPerformance.aopGap')
        }
      };
    },
    listApi: function listApi() {
      return {
        apiUrl: '/protected/app/store/report/city/performance'
      };
    }
  },
  methods: {
    toDetailPage: function toDetailPage(e) {
      console.log('toDetailPage -- ', e);
      this.$router.push({
        path: '/reportModule/salesPerformance/salesPerformanceStore',
        query: {
          regionCode: e.regionCode || '',
          cityCode: e.cityCode || ''
        }
      });
    }
  }
};